<p-table [value]="projectOrganizationArray" #defaultTable>
    <ng-template pTemplate="header">
        <tr>
            <th>{{ 'fs.res.common.organizations.internal.defaulttext' | hisUi }}</th>
            <th *ngIf="!isInformationHidden"> {{ 'fs.res.project.Project.organizations.additionalOrg.information.label' | hisUi }}</th>
            <th>{{'common.actions' | hisUi }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-org>
        <tr>
            <td>{{org.organization.text}}</td>
            <td *ngIf="!isInformationHidden">{{org.information}}</td>
            <td class="singleLine">
                <button *ngIf="!isInformationHidden" (click)="showInformationPopUp(org)"
                        hisImage="PENCIL" class="icon" title="{{'common.editOf' | hisUi:(org.organization.text)}}"></button>
                <button (click)="deleteOrg(org)" hisImage="DELETE" class="icon"
                        title="{{'common.removeAssignmentOf' | hisUi:(org.organization.text)}}">
                </button>
            </td>
        </tr>
    </ng-template>
</p-table>
<res-organization-information-dialog *ngIf="currentOrg"
                                            [(visibility)]="informationDialogVisibility"
                                            [(organization)]="currentOrg">
</res-organization-information-dialog>